// Import Packages
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

// Import Helper
import { CheckIfFlowUpdated } from "../../../../helpers/helper";

// Import Material UI
import { Box } from "@material-ui/core";

// Import Pages
import { TextInput } from "../../../FlowConfigurationInputs/TextInput/NewTextInput";
import { CredentialPicker } from "../../../FlowConfigurationInputs/CredentialPicker/CredentialPicker";
import FieldLabel from '../../../FlowConfigurationInputs/FieldLabel/FieldLabel';

// Import Recoil
import { changedFields, initialActions, saveAvailable } from "../../../../recoil-store/recoil-state";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import AuthenticationType from "./AuthenticationType/AuthenticationType";

function TabPanel({ children, value, index }) {
    return <div>{value === index && <Box>{children}</Box>}</div>;
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function Connect({ action, variables, setOpenVariable, automId, showAlert }) {
    const { t } = useTranslation();
    const label = "CONTENT.CONFIGURATION-FORM.FTP-SFTP.CONNECT.";
    const [serverType, setServerType] = useState("ftp");
    const [isTabChanged, setIsTabChanged] = useState(false);
    const initialActionsData = useRecoilValue(initialActions);
    const setSaveAvailable = useSetRecoilState(saveAvailable);
    const [changedFieldsState, setChangeFields] = useRecoilState(changedFields);


    useEffect(() => {
        if (!action.fields.serverType) {
            action.fields.serverType = { value: "ftp", isRequired: true }
        } else {
            setServerType(action.fields.serverType.value)
        }
        if (!action.fields.transferType) {
            action.fields.transferType = { value: "binary" }
        }
        if (!action.fields.authenticationType) {
            action.fields.authenticationType = { value: "anonymous" }
        }
    }, [])

    const handleClick = (e) => {
        let value = e.target.value;

        const field = initialActionsData[action.id]?.fields["serverType"];
        const oldValue = !field ? undefined : field.value;
        CheckIfFlowUpdated("serverType", action, oldValue, value, setSaveAvailable, setChangeFields, changedFieldsState);
        if (value !== "sftp") {
            delete action.fields.loginPass
            delete action.fields.loginUser
            delete action.fields.filePath
        }
        action.fields.serverType = { value };
        setIsTabChanged(true);
        setServerType(value);
    };

    return (
        <div>
            <div className="conf-field-container">
                <FieldLabel name={t(label + "SERVER-NAME")} is_required={true} />
                <TextInput
                    action={action}
                    inputName="serverName"
                    variables={variables}
                    setOpenVariable={setOpenVariable}
                    isRequired
                    hideRequired={true}
                />
                <small
                    className="conf-field-desc"><em>{t(label + 'SERVER-NAME-HELP')}</em></small>
            </div>
            <div className="conf-field-container">
                <FieldLabel name={t(label + "PORT")} is_required={true} />
                <TextInput
                    action={action}
                    inputName="port"
                    variables={variables}
                    setOpenVariable={setOpenVariable}
                    isRequired={true}
                    hideRequired={true}
                />
                <small
                    className="conf-field-desc"><em>{t('CONTENT.CONFIGURATION-FORM.INPUT-VALUE-HELPER', { type: 'number' })}</em></small>
            </div>
            <div className="conf-field-container condition-tabs">
                <FieldLabel name={t(label + "SERVER-TYPE")} />
                <button className={serverType === 'ftp' ? 'condition-active' : ''}
                    value="ftp" onClick={handleClick}>
                    FTP
                </button>
                <button className={serverType === 'ftps' ? 'condition-active' : ''}
                    value="ftps" onClick={handleClick}>
                    {t(label + 'FTPS')}
                </button>
                <button className={serverType === 'sftp' ? 'condition-active' : ''}
                    value="sftp" onClick={handleClick}>
                    {t(label + 'SFTP')}
                </button>
            </div>

            <AuthenticationType serverType={serverType} action={action} variables={variables} setOpenVariable={setOpenVariable}
                isTabChanged={isTabChanged} automId={automId} showAlert={showAlert} />
        </div>
    );
}

export default Connect;